import { useDocumentationBrowserState } from 'components/documentation/DocumentationBrowser';

export function useExportToDocumentationBrowser(isOpen: boolean) {
  return useDocumentationBrowserState({
    isOpen,
    selectableDocumentation: false,
  });
}
